export type PlaceBarInsets = { left: boolean; right: boolean }

// The global corner controls (sidebar button on the left, avatar on the right)
// float over the top of the panel row. A panel's place bar clears only the
// corners that land on it: both in one-panel mode, and in the multi-panel row
// the left corner on the left-most visible panel and the right corner on the
// right-most (the bar itself only shows on the centre panel there, which
// clears neither). On phones a thread hides the corners (cornersHidden) so the
// bar's breadcrumb gets the full width.
export function resolvePlaceBarInsets({
    onePanel,
    cornersHidden = false,
    centerIndex,
    numPanels,
    panelIndex,
}: {
    onePanel: boolean
    cornersHidden?: boolean
    centerIndex: number
    numPanels: number
    panelIndex: number | undefined
}): PlaceBarInsets {
    if (onePanel) {
        return { left: !cornersHidden, right: !cornersHidden }
    }
    const leftmost = centerIndex - Math.floor((numPanels - 1) / 2)
    const rightmost = leftmost + numPanels - 1
    return {
        left: panelIndex === leftmost,
        right: panelIndex === rightmost,
    }
}
